import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BuildingService } from '../../../core/services';
import { asyncScheduler, firstValueFrom } from 'rxjs';
import { Building } from '../../../core/models/building';
import { TableColumn, TableViewComponentBase } from '../table-view/table-view-component-base';

export type ProximityCriteria = {
  srcLocId?: string; // keep track of selected building or point so UI can update selected drop downs
  srcLocType?: 'building' | 'point';
  lat: number;
  lng: number;
  meters: number;
};


export const editTableColumnProximity = async (table: TableViewComponentBase<any>, column: TableColumn, newValSetter: (newVal:string)=>void) => {
  const parseCriteria = (strCriteria:string) => {
    if ( strCriteria ) {
      try {
        return JSON.parse(strCriteria);
      } catch ( e: any) {
        console.error(e);
        table.appState.notifyError('Invalid proximity filter: ' + strCriteria, this, 5);
      }
    }
    return {lat:0,lng:0,meters:120};
  }
  const criteria: ProximityCriteria = parseCriteria(column.filter?.value);  
  const modalRef = ProximityModalComponent.show(table.modalService, criteria);
  await firstValueFrom(modalRef.onHidden);
  if ( modalRef.content.bCancelled ) {
    return false;
  }
  const value = modalRef.content.proximityCriteria?JSON.stringify(modalRef.content.proximityCriteria):'';
  console.log({value});
  if ( newValSetter ) {
    // probably from table config modal
    newValSetter(value);
  } else if ( column.filter?.value != value ) {
    // no dest filter so assume it is column's header filter
    console.log('value changed',{value});
    if ( !column.filter ) {
      column.filter = {
        key: column.name,
        mode: '=',
        value
      }
    } else {
      column.filter.value = value;
    }
    table.load();
  }
  return true;
}


@Component({
  selector: 'proximity-modal',
  templateUrl: './proximity-modal.component.html',
  styleUrls: ['./proximity-modal.component.scss']
})
export class ProximityModalComponent implements OnInit {  
  
  static show( modalService: BsModalService, proximityCriteria: ProximityCriteria, modalClass='modal-sm' )  {
    return modalService.show(ProximityModalComponent, {
      ignoreBackdropClick: true,
      initialState: { proximityCriteria },
      class: modalClass,
    });  
  }

  @Input() proximityCriteria: ProximityCriteria;  

  bCancelled = false;
  formData: ProximityCriteria;
  buildings: Partial<Building>[] = [];
  bBuildingsLoading = false;
  selectedBuilding: Partial<Building> = null;

  constructor(
    public buildingService: BuildingService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    this.formData = JSON.parse(JSON.stringify(this.proximityCriteria));
    asyncScheduler.schedule(async ()=> {
      try {
        this.bBuildingsLoading = true;
        this.buildings = await this.buildingService.restClient.findRows({
          sorts: [ {key:'id',order:'ASC'}],
          respEntityFields: ['id','commonName','civicLatitude','civicLongitude'],          
        });
        if ( this.formData.srcLocId && this.formData.srcLocType == 'building' ) {
          this.selectedBuilding = this.buildings.find(b=>b.id == this.formData.srcLocId);
        }
      } catch (e:any) {
        this.buildingService.publishErrorObj(e,'Failed loading buildings',this,5);
      } finally {
        this.bBuildingsLoading = false;
      }
    })
  }

  onBuildingIdChange(building: Partial<Building>) {
    this.selectedBuilding = building;
    console.log(building)
    if ( !building ) {
      this.formData.srcLocId = null;
      this.formData.srcLocType = null;
      return;
    }
    this.formData = {
      lat: building.civicLatitude,
      lng: building.civicLongitude,
      meters: this.formData?.meters || 120,
      srcLocId: building.id,
      srcLocType: 'building',
    };
  }

  clear() {
    this.proximityCriteria = null;
    this.bCancelled = false;
    this.bsModalRef.hide()
  }

  ok() {
    this.proximityCriteria = this.formData;
    this.bCancelled = false;
    this.bsModalRef.hide()
  }

  cancel() {
    this.bCancelled = true;
    this.bsModalRef.hide()
  }
}